import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDescriptionProps {
  description: string;
}

export const Description: React.FC<IDescriptionProps> = ({ description }) => {
  return (
    <div className={styles['description']}>
      <UIText3 color="surface-neutral-pressed">
        <span className={styles['text']}>{description}</span>
      </UIText3>
    </div>
  );
};
